import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { startSound } from 'shared/lib';
import { Lighting } from 'shared/ui';
import { betMenuModel } from '../../model';
import { BetMenuBetButton } from '../bet-menu-bet-button';
import { BetMenuFastBets } from '../bet-menu-fast-bets';
import { BetMenuWagerField } from '../bet-menu-wager-field';
import cls from './bet-menu.module.scss';

type BetMenuProps = {
	className?: string;
	onReadonlyClick?: () => void;
};

export const BetMenu = ({ className, onReadonlyClick }: BetMenuProps) => {
	const [submit, startPlay, enableOnboarding] = useUnit([
		betMenuModel.betFormSubmitted,
		startSound.play,
		betMenuModel.$enableOnboardingBetMenu,
	]);

	return (
		<Lighting
			enabled={enableOnboarding}
			className={cls.betMenuLighting}
		>
			<form
				className={clsx(cls.betMenu, className)}
				onSubmit={(event) => {
					event.preventDefault();
					submit();
					startPlay();
				}}
			>
				<BetMenuWagerField onReadonlyClick={onReadonlyClick} />
				<BetMenuBetButton />
				<BetMenuFastBets />
			</form>
		</Lighting>
	);
};
